(function() {
    'use strict';
    
    let stickyBar = null;
    let atcButton = null;
    let productMain = null;
    let observer = null;
    let footerObserver = null;
    let isAtcVisible = false;
    let isFooterVisible = false;
    
    // Main initialization
    function init() {
        // Find elements
        stickyBar = document.querySelector('.product-sticky');
        
        if (!stickyBar) {
            setTimeout(init, 500);
            return;
        }
        
        // Remove theme's hidden class if present
        stickyBar.classList.remove('product-sticky--hidden');
        
        // Find the main ATC button (not the sticky one)
        findMainAtcButton();
        
        // Find the product main element for scrolling
        findProductMain();
        
        // Setup observers
        setupObservers();
        
        // Setup click handler for sticky ATC
        setupStickyClickHandler();
        
        // Setup click handler for edit/arrow button
        setupEditButtonListener(); // Added this line
        
        // Listen for dynamic content
        setupDynamicDetection();
    }
    
    // Find the main ATC button (exclude the sticky one)
    function findMainAtcButton() {
        const allAtcButtons = document.querySelectorAll('.add-to-cart');
        
        for (const button of allAtcButtons) {
            // Skip buttons inside the sticky bar
            if (button.closest('.product-sticky')) {
                continue;
            }
            
            // Check if button is actually visible and has size
            const rect = button.getBoundingClientRect();
            if (rect.width > 10 && rect.height > 10) {
                atcButton = button;
                console.log('Found main ATC button:', atcButton);
                break;
            }
        }
        
        // Fallback: look for submit button in product form
        if (!atcButton) {
            const productForm = document.querySelector('form[action*="/cart/add"]');
            if (productForm) {
                atcButton = productForm.querySelector('button[type="submit"]');
            }
        }
    }
    
    // Find the product main element for scrolling
    function findProductMain() {
        // Try the same selector used in the original component
        productMain = document.querySelector('.product-grid__content');
        
        // If not found, try other common selectors
        if (!productMain) {
            productMain = document.querySelector('.product__main, .product-main, .product-details, .product-info');
        }
        
        // Fallback to the product form
        if (!productMain) {
            const productForm = document.querySelector('form[action*="/cart/add"]');
            if (productForm) {
                productMain = productForm.closest('.product-form, form[action*="/cart/add"]');
            }
        }
        
        console.log('Found product main element:', productMain);
    }
    
    // Setup observers with proper state management
    function setupObservers() {
        // Clean up existing observers
        if (observer) observer.disconnect();
        if (footerObserver) footerObserver.disconnect();
        
        // Reset states
        isAtcVisible = false;
        isFooterVisible = false;
        
        // Observer for main ATC button
        if (atcButton) {
            observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    isAtcVisible = entry.isIntersecting;
                    updateStickyBar();
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            });
            
            observer.observe(atcButton);
        }
        
        // Observer for footer with BOTH enter and exit tracking
        const footer = document.querySelector('footer, .site-footer');
        if (footer) {
            footerObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    isFooterVisible = entry.isIntersecting;
                    updateStickyBar();
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px 0px 0px'
            });
            
            footerObserver.observe(footer);
        }
        
        // If no ATC found, show sticky bar
        if (!atcButton) {
            showStickyBar();
        }
    }
    
    // Update sticky bar based on current states
    function updateStickyBar() {
        // Show sticky bar when:
        // 1. ATC is NOT visible AND
        // 2. Footer is NOT visible
        // Otherwise, hide it
        
        if (!isAtcVisible && !isFooterVisible) {
            showStickyBar();
        } else {
            hideStickyBar();
        }
    }
    
    // Show sticky bar (only changes opacity/visibility)
    function showStickyBar() {
        if (!stickyBar) return;
        
        // Use inline styles to avoid CSS conflicts
        stickyBar.style.opacity = '1';
        stickyBar.style.visibility = 'visible';
        stickyBar.style.pointerEvents = 'auto';
        stickyBar.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
    }
    
    // Hide sticky bar (only changes opacity/visibility)
    function hideStickyBar() {
        if (!stickyBar) return;
        
        stickyBar.style.opacity = '0';
        stickyBar.style.visibility = 'hidden';
        stickyBar.style.pointerEvents = 'none';
        stickyBar.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
    }
    
    // Setup click handler for sticky ATC
    function setupStickyClickHandler() {
        const stickyAtc = stickyBar.querySelector('.btn-sticky-atc, [data-ref="submitButton"]');
        if (!stickyAtc || !atcButton) return;
        
        // Clone to remove existing listeners
        const newButton = stickyAtc.cloneNode(true);
        stickyAtc.parentNode.replaceChild(newButton, stickyAtc);
        
        newButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Visual feedback
            const originalText = this.textContent;
            this.textContent = 'Adding...';
            this.disabled = true;
            
            // Click main ATC button
            if (atcButton && !atcButton.disabled) {
                atcButton.click();
            }
            
            // Restore button
            setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
            }, 2000);
        });
    }
    
    // Setup click handler for edit/arrow button - ADDED THIS FUNCTION
    function setupEditButtonListener() {
        const editButton = stickyBar.querySelector('.product-sticky__actions__edit, [data-ref="editButton"]');
        if (!editButton) return;
        
        // Remove existing listeners and add new one
        const newEditButton = editButton.cloneNode(true);
        editButton.parentNode.replaceChild(newEditButton, editButton);
        
        newEditButton.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('Edit button clicked');
            
            if (productMain) {
                // Scroll to the product main element smoothly
                productMain.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            } else {
                // Fallback: scroll to the top of the page or try to find the element again
                findProductMain();
                if (productMain) {
                    productMain.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                } else {
                    // Ultimate fallback: scroll to the product form
                    const productForm = document.querySelector('form[action*="/cart/add"]');
                    if (productForm) {
                        productForm.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }
            }
        });
    }
    
    // Listen for dynamic changes
    function setupDynamicDetection() {
        // Re-check when variants change
        document.addEventListener('change', function(e) {
            if (e.target.matches('[name*="variant"], [name*="option"], select')) {
                setTimeout(() => {
                    findMainAtcButton();
                    setupObservers();
                }, 300);
            }
        });
        
        // Reinitialize on AJAX updates
        if (window.jQuery) {
            jQuery(document).on('ajaxComplete', function() {
                setTimeout(init, 500);
            });
        }
    }
    
    // Manual scroll check as backup
    function setupScrollBackup() {
        let lastScrollTop = 0;
        let ticking = false;
        
        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    if (atcButton) {
                        const rect = atcButton.getBoundingClientRect();
                        const isVisible = rect.top >= 0 && rect.top <= window.innerHeight;
                        
                        // Update state
                        isAtcVisible = isVisible;
                        updateStickyBar();
                    }
                    
                    ticking = false;
                });
                ticking = true;
            }
        });
    }
    
    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(init, 1000);
            setupScrollBackup();
        });
    } else {
        setTimeout(init, 1000);
        setupScrollBackup();
    }
    
    // Safety re-check after full load
    window.addEventListener('load', function() {
        setTimeout(init, 1500);
    });
})();